var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCopy(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 12,
    viewBox: "0 0 10 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.00263 11.9123C0.772761 11.9123 0.571627 11.8261 0.399226 11.6537C0.226825 11.4813 0.140625 11.2802 0.140625 11.0503V2.38719H1.00263V11.0503H7.81245V11.9123H1.00263ZM2.72663 10.1883C2.49677 10.1883 2.29563 10.1021 2.12323 9.92971C1.95083 9.75731 1.86463 9.55618 1.86463 9.32631V1.28095C1.86463 1.05108 1.95083 0.849947 2.12323 0.677546C2.29563 0.505146 2.49677 0.418945 2.72663 0.418945H9.04799C9.27786 0.418945 9.47899 0.505146 9.65139 0.677546C9.82379 0.849947 9.90999 1.05108 9.90999 1.28095V9.32631C9.90999 9.55618 9.82379 9.75731 9.65139 9.92971C9.47899 10.1021 9.27786 10.1883 9.04799 10.1883H2.72663Z",
    fill: "#C4C4C4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopy);
export default __webpack_public_path__ + "static/media/copy.2cff0244cd027512f4d04fb2d564ea77.svg";
export { ForwardRef as ReactComponent };